import React, { Component } from 'react';
import _ from 'underscore';
import { urls, dom, fetch, postMessage } from '../../utils';
import { NoContent, CenterBlock, Icon } from '../../ui';
import Item from '../item';

export default class extends Component {
    async loadData({ session, scroll }, force) {
        const { data, user, actions } = this.props;
        let res = {};
        let existed = false;
        let messages = [];

        if (session) {
            existed = _.find(data, { session_id: session.id });
            if (force || !existed) {
                res = await fetch(urls.api.msg.list, {
                    method: "POST",
                    data: {
                        id: session.id,
                        next: session._msgNext
                    }
                });

                //#test
                // res = require('../../tests').messages

                if (res.ok) {
                    _.each(res.messages, (item) => {
                        (item.from !== user.jid) && (item.is_received = true);
                        messages.unshift(item);
                    });
                    session._msgNext = res.next;
                    actions.insertOrEdit(messages);
                }
            }

            scroll && this.scrollTop({ session });
        }

        return res;
    }

    scrollTop({ session, time = 100 }) {
        let top, el;

        setTimeout(() => {
            el = dom(this)[0];
            top = session._scrollTop;
            top = isNaN(top) ? el.scrollHeight + 200 : top;
            el.scrollTop = top;
            session._scrollTop = el.scrollTop;
        }, time);
    }

    goBottom() {
        const { session } = this.props;

        if (session) {
            delete session._scrollTop;
            this.scrollTop({ session });
        }
    }

    async viewMore() {
        const { session } = this.props;

        if (session && !session._isLoadingMsg) {
            session._isLoadingMsg = true;
            await this.loadData({ session }, true);
            delete session._isLoadingMsg;
        }
    }

    onScroll(ev) {
        const { session = {} } = this.props;

        let scrollTop = ev.target.scrollTop;;
        session._scrollTop = scrollTop;

        // if (scrollTop < 50) {
        //     if (!session._isLoadingMsg) {
        //         session._isLoadingMsg = true;
        //         if (session._msgNext) {
        //             await this.loadData({ session }, true);
        //         }

        //         setTimeout(() => {
        //             delete session._isLoadingMsg;
        //             this.forceUpdate();
        //         }, 50);
        //     }
        // }
    }

    onPreview(currItem) {
        const { data } = this.props;
        const { type, message_id } = currItem.body;

        if (type === "image") {
            let index = 0;
            let imgIndex = 0;
            let imgArr = [];
            _.each(data, (item) => {
                let body = item.body || {};
                if (body.type === type) {
                    imgArr.push(body.file_src);
                    if (message_id === body.message_id) {
                        index = imgIndex;
                    }
                    imgIndex++;
                }

            });

            postMessage('image.preview', {
                images: imgArr,
                index
            });
        }
    }

    render() {
        const { session = {}, data, actions, onReSend } = this.props;
        const messages = _.filter(data, { session_id: session.id })

        return (
            <div className="msg-list scroll-y" onScroll={this.onScroll.bind(this)}>
                {
                    session._msgNext ?
                    <CenterBlock><a onClick={this.viewMore.bind(this)}>查看更多</a></CenterBlock> :
                    null
                }
                {
                    (session && messages.length) ? 
                        messages.map(item=>{
                            return (
                                <Item key={item.id} data={item} actions={actions} 
                                      onPreview={this.onPreview.bind(this)}
                                      onReSend={onReSend} />
                            )
                        }) : 
                        <NoContent text="无消息"/>
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/msg/list/index.js